"use strict";
/* eslint-disable zillow/@typescript-eslint/naming-convention */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFrame = exports.PageFrameComponent = void 0;
const react_1 = __importDefault(require("react"));
const Head_1 = require("./Head");
const BodyScripts_1 = require("./pageFrameService/BodyScripts");
const CoreScripts_1 = require("./pageFrameService/CoreScripts");
const Footer_1 = require("./pageFrameService/Footer");
const HeadTags_1 = require("./pageFrameService/HeadTags");
const PageFrameContext_1 = require("./pageFrameService/PageFrameContext");
const RegLogin_1 = require("./pageFrameService/RegLogin");
const Topnav_1 = require("./pageFrameService/Topnav");
/*
 * PageFrame and PageFrameBody components serve different users:
 *   - PageFrame:
 *     - For sub-apps using the Shopper Platform, does not create new <BODY> or <HEAD> blocks
 *     - Only adds to existing <HEAD> of the DOM, does not create new <HEAD> blocks
 *   - PageFrameBody:
 *     - For individual Next.js applications, creates new <BODY> and <HEAD> blocks
 */
var PageFrameComponent;
(function (PageFrameComponent) {
    PageFrameComponent["HEADTAGS"] = "headTags";
    PageFrameComponent["TOPNAV"] = "topnav";
    PageFrameComponent["FOOTER"] = "footer";
    PageFrameComponent["REGLOGIN"] = "reg";
    PageFrameComponent["BODYSCRIPTS"] = "bodyScripts";
})(PageFrameComponent || (exports.PageFrameComponent = PageFrameComponent = {}));
/**
 * Page Frame component for Shopper Platform sub-apps.
 */
const PageFrame = ({ pageFrameData, components, children, }) => (react_1.default.createElement(PageFrameContext_1.PageFrameContext.Provider, { value: pageFrameData },
    components.includes(PageFrameComponent.HEADTAGS) && react_1.default.createElement(HeadTags_1.HeadTags, { Container: Head_1.Head }),
    components.includes(PageFrameComponent.TOPNAV) && react_1.default.createElement(Topnav_1.Topnav, null),
    children,
    components.includes(PageFrameComponent.FOOTER) && react_1.default.createElement(Footer_1.Footer, null),
    components.includes(PageFrameComponent.REGLOGIN) && react_1.default.createElement(RegLogin_1.RegLogin, null),
    components.includes(PageFrameComponent.BODYSCRIPTS) && react_1.default.createElement(BodyScripts_1.BodyScripts, null),
    react_1.default.createElement(CoreScripts_1.CoreScripts, { components: components })));
exports.PageFrame = PageFrame;
